<!-- eslint-disable vue/no-mutating-props -->
<template>
    <Dialog v-model:visible="editItemDialog" :style="{width: '450px'}" header="Data Detail" :modal="true" class="p-fluid">
         <div class="field">
            <label>Outlet Code</label>
            <InputText v-model="item.outlet_code" :class="{ 'p-invalid': errorEdit.outlet_code }"/>
            <small class="p-invalid" style="color: red" v-if="errorEdit.outlet_code" >{{ errorEdit.outlet_code[0] }}</small >
        </div>
         <div class="field">
            <label>Outlet Name</label>
            <InputText v-model="item.outlet_name" :class="{ 'p-invalid': errorEdit.outlet_name }"/>
            <small class="p-invalid" style="color: red" v-if="errorEdit.outlet_name" >{{ errorEdit.outlet_name[0] }}</small >
        </div>
        <div class="field">
            <label>Outlet Type</label>
            <Dropdown dataKey="label" 
                    ref="doutlettype" v-model="item.otype_id" 
                    :loading="loadingDropdownOutletType" 
                    :options="dataDropdownOutletType" 
                    :class="{ 'p-invalid': errorEdit.otype_id }" 
                    optionLabel="otype_name" optionValue="otype_id" 
                    placeholder="Select Outlet Type" :filter="true" 
                    :showClear="true" @filter="searchDropdownType($event,'edit')"
            />
            <small class="p-invalid" style="color: red" v-if="errorEdit.otype_id" >{{ errorEdit.otype_id[0] }}</small>
        </div>
         <div class="field">
            <label>Outlet Contact Person</label>
            <InputText v-model="item.outlet_owner" :class="{ 'p-invalid': errorEdit.outlet_owner }"/>
            <small class="p-invalid" style="color: red" v-if="errorEdit.outlet_owner" >{{ errorEdit.outlet_owner[0] }}</small >
        </div>
         <div class="field">
            <label>Outlet Contact Number</label>
            <InputText v-model="item.outlet_phone" :class="{ 'p-invalid': errorEdit.outlet_phone }"/>
            <small class="p-invalid" style="color: red" v-if="errorEdit.outlet_phone" >{{ errorEdit.outlet_phone[0] }}</small >
        </div>
         <div class="field">
            <label>Outlet Address</label>
            <InputText v-model="item.outlet_address" :class="{ 'p-invalid': errorEdit.outlet_address }"/>
            <small class="p-invalid" style="color: red" v-if="errorEdit.outlet_address" >{{ errorEdit.outlet_address[0] }}</small >
        </div>
         <div class="field">
            <label>Outlet Latitude</label>
            <InputText v-model="item.lat" :class="{ 'p-invalid': errorEdit.lat }"/>
            <small class="p-invalid" style="color: red" v-if="errorEdit.lat" >{{ errorEdit.lat[0] }}</small >
        </div>
         <div class="field">
            <label>Outlet Longitude</label>
            <InputText v-model="item.lng" :class="{ 'p-invalid': errorEdit.lng }"/>
            <small class="p-invalid" style="color: red" v-if="errorEdit.lng" >{{ errorEdit.lng[0] }}</small >
        </div>
         <div class="field">
            <label>Outlet Status</label>
            <Dropdown v-model="item.outlet_status" :options="dataDropdownStatus" optionLabel="name" optionValue="code" placeholder="Select Status" :class="{ 'p-invalid': errorEdit.outlet_status }"/>
                <small class="p-invalid" style="color: red" v-if="errorEdit.outlet_status" >{{ errorEdit.outlet_status[0] }}</small>
        </div>
        <div class="field">
            <label>Outlet City</label>
            <Dropdown dataKey="label" 
                    ref="dcity" v-model="item.city_id" 
                    :loading="loadingDropdownCity" 
                    :options="dataDropdownCity" 
                    :class="{ 'p-invalid': errorEdit.city_id }" 
                    optionLabel="label" optionValue="city_id" 
                    placeholder="Select City" :filter="true" 
                    :showClear="true" @filter="searchDropdownCity($event,'edit')"
            />
            <small class="p-invalid" style="color: red" v-if="errorEdit.new_city_id || errorEdit.old_city_id" >The City field is Invalid/Already exists</small>
        </div>
        <template #footer>
            <Button label="Cancel" icon="pi pi-times" class="p-button-text" @click="hideDialog"/>
            <Button label="Update" icon="pi pi-check" class="p-button-text" @click="updateItem" :loading="loading"/>
        </template>
    </Dialog>
</template>


<script>

import { mapGetters } from "vuex";

export default {
    props: [
		"item",
    ],
    data() {
        return {
            // loading
            loading: false,
            loadingDropdownCity: false,
            loadingDropdownOutletType: false,

            // dataDropdown
            dataDropdownStatus: [
                {name: 'ACTIVE', code: 'y'},
                {name: 'NON ACTIVE', code: 'n'},
            ],
            dataDropdownCity: null,
            dataDropdownOutletType: null,
            
            old_city_id: null,

            // edit
            editItemDialog: false,
        }
    },
    mounted() {
        this.$store.commit('setErrorEdit', {});
    },
    watch: {
        editItemDialog: {
            handler() {
                setTimeout(() => {
                    if(this.editItemDialog == true){
                        this.searchDropdownCity('', 'edit', this.item.territory_name +'-'+ this.item.city_name);
                        this.searchDropdownOutletType('', 'edit', this.item.otype_name);
                        this.old_city_id = this.item.city_id;
                    }
                    this.$store.commit('setErrorEdit', {});
                }, 500);
            },
        }
    },
    computed:{
        ...mapGetters(['errorEdit']),
		...mapGetters("auth", ["user"]),
    },
    methods: {
        searchDropdownCity(event, purpose, valueEdit){
            setTimeout(() => {
                if(valueEdit){
                    this.$refs.dcity.filterValue = valueEdit;
                }

                if(purpose == "edit"){
                    this.loadingDropdownCity = true;
                }

                this.axios({
                    method: 'GET',
                    url: process.env.VUE_APP_ROOT_API + 'web/select2/master-city3',
                    params: {
                        "search" : valueEdit ? valueEdit : event.value,
                    }
                })
                .then(res => {

                    if(purpose == "edit"){
                        this.dataDropdownCity = res.data.data;
                        this.loadingDropdownCity = false;
                    }else if(purpose == null){
                        this.dataDropdownCity = res.data.data;
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
            }, 250);
        },
        searchDropdownOutletType(event, purpose, valueEdit){
            setTimeout(() => {
                if(valueEdit){
                    this.$refs.doutlettype.filterValue = valueEdit;
                }

                if(purpose == "edit"){
                    this.loadingDropdownOutletType = true;
                }

                this.axios({
                    method: 'GET',
                    url: process.env.VUE_APP_ROOT_API + 'web/select2/outlet-type',
                    params: {
                        "search" : valueEdit ? valueEdit : event.value,
                    }
                })
                .then(res => {

                    if(purpose == "edit"){
                        this.dataDropdownOutletType = res.data.data;
                        this.loadingDropdownOutletType = false;
                    }else if(purpose == null){
                        this.dataDropdownOutletType = res.data.data;
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
            }, 250);
        },
        // EDIT
		hideDialog() {
			this.editItemDialog = false;
		},
		updateItem() {
            this.loading = true;

            this.axios({
                method: 'POST',
                url: process.env.VUE_APP_ROOT_API + 'web/outlet/update',
                data: {
                    "outlet_id": this.item.outlet_id,
                    "outlet_code": this.item.outlet_code,
                    "outlet_name": this.item.outlet_name,
                    "outlet_owner": this.item.outlet_owner,
                    "outlet_phone": this.item.outlet_phone,
                    "outlet_address": this.item.outlet_address,
                    "lat": this.item.lat,
                    "lng": this.item.lng,
                    "outlet_status" : this.item.outlet_status,
                    "old_city_id" : this.old_city_id,
                    "new_city_id" : this.old_city_id !== this.item.city_id ? this.item.city_id : null, 
                    "otype_id" : this.item.otype_id,
                },
            })
            .then((res) => {
                this.loading = false;
                if (res) {
                    this.$toast.add({ severity: 'success', summary: 'Successful', detail: 'Data Successfully Saved', life: 3000,});
                    this.$store.commit('setErrors', {});
                    this.$store.commit('setErrorEdit', {});
                    // this.item = {};
                    this.editItemDialog = false;
                    this.$emit('submit');
                }
            })
            .catch((err) => {
                console.log(err);
                this.loading = false;
                this.$store.commit('setErrorEdit', err.response.data.data);
                this.$toast.add({ severity: 'error', summary: 'Failed', detail: 'Data Failed to Saved', life: 3000,});
            });
		},
    }
}
</script>